import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API } from "@/lib/content";
import { errorText } from "@/lib/errors";

export const NewsletterSignup = ({ dark = false, testId = "newsletter" }) => {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await axios.post(`${API}/newsletter/subscribe`, { email });
      setSent(true);
    } catch (err) {
      toast.error(errorText(err));
    } finally {
      setBusy(false);
    }
  };

  const ink = dark ? "text-sage" : "text-pine";
  const muted = dark ? "text-mist/80" : "text-moss";
  if (sent) {
    return <p className={`${muted}`} data-testid={`${testId}-sent`}>Almost done. Check your email and tap the link to confirm.</p>;
  }
  return (
    <form onSubmit={submit} className="flex flex-wrap items-end gap-3" data-testid={`${testId}-form`}>
      <label className={`flex-1 min-w-[220px] text-sm ${muted}`}>
        Get new free guides by email
        <input
          required
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@example.com"
          className={`mt-1 block w-full bg-transparent border-b ${dark ? "border-mist/40 placeholder:text-mist/40" : "border-pine/40 placeholder:text-moss/50"} ${ink} py-2 text-base focus:outline-none focus:border-brass transition-colors`}
          data-testid={`${testId}-email-input`}
        />
      </label>
      <button
        type="submit"
        disabled={busy}
        className={`rounded-full px-6 py-3 text-sm transition-colors disabled:opacity-70 ${dark ? "bg-sage text-pine hover:bg-white" : "bg-pine text-sage hover:bg-pine-soft"}`}
        data-testid={`${testId}-submit-button`}
      >
        {busy ? "Signing up..." : "Sign me up"}
      </button>
    </form>
  );
};
